import * as React from "react";
import { CommentEditor } from "../../../../../pageComponents/CommentEditor";
import { Box, Button, Grid, makeStyles, TextField, Typography } from "@material-ui/core";
import { MUITooltip } from "../..";
import { textRichToPlain, textPlainToRich } from "../../../../../utils";
import { SvgIcon } from "../../../../../components";
import * as styles from "../styles.scss";
import { EmbededFilestorage } from "../../../Filestorage";
import { editorExtended } from "../../../../../pageComponents/CommentEditor/styles.scss";
import { observer } from "mobx-react";

interface IProps {
  value?: string;
  placeholder?: string;
  rows?: number;
  rowsMax?: number;

  hint?: string;
  attachAllowed?: boolean;
  attachCourse?: number;
  editorAllowed?: boolean;
  onPreview?: any;
  editor?: boolean;
  editorNotification?: string;
  newFormats?: boolean;
  simple?: boolean;
  onEditorChange?: (on: boolean) => void;
  hasPanel?: boolean;
  onChange?: any;
}

const useStyles = makeStyles({
  containedPrimary: {
    backgroundColor: "#54667C",

    "&:hover": {
      backgroundColor: "#54667C",
    },
  },
})

export const TextEditor = (props: IProps) => {
  const [editor, setEditor] = React.useState(props.editor);
  const [value, setValue] = React.useState(props.value);
  const editorRef = React.useRef(null);

  React.useEffect(() => {
    if (!hasPanel) {
      setEditor(props.editor)
      setValue(props.value)
      handleEditorChange(props.editor)
    }
  }, [props.editor])

  React.useEffect(() => {
    if (!props.editor) {
      setValue(textRichToPlain(value));
    }
  },[])

  const handleEditorChange = (on: boolean) => {
    if (on) {
      setValue(textPlainToRich(value));
    } else {
      setValue(textRichToPlain(value));
    }
    setEditor(on);
    props.onEditorChange && props.onEditorChange(on)
  }

  const buttonClasses = useStyles();

  // filestorage
  const [isFilestorageOpen, setFilestorageOpen] = React.useState(false);
  const onFileAdd = () => {
    (window as any).showEmbededFilestorage();
    setFilestorageOpen(true);
  };
  const onFileAddConfirm = (data: any) => {
    const fileCode =
      typeof data === "string"
        ? ` ${data} `
        : data.reduce((acc: string, a: any) => {
            acc += ` ${a.attachedCode ? a.attachedCode : a.code} `;
            return acc;
          }, ``);
    if (!editorRef.current) {
      return;
    }
    if (editor) {
      const newValue = editorRef.current.inserFileCode(fileCode);
      setValue(newValue);
      props.onChange(newValue);
    } else {
      const textareaElement = editorRef.current.querySelector(`textarea`);
      const newValue =
        textRichToPlain(value).substring(0, textareaElement.selectionStart) +
        fileCode +
        textRichToPlain(value).substring(textareaElement.selectionEnd);
      setValue(newValue);
      props.onChange(newValue);
    }
    (window as any).closeEmbededFilestorage();
    setFilestorageOpen(false);
  };
  // filestorage -- end

  const hasPanel =
    props.hasPanel ||
    props.hint ||
    props.attachAllowed ||
    props.editorAllowed ||
    props.onPreview;

  return (
    <Grid container wrap="nowrap">
      <Grid item xs className={styles.editor}>
        {editor ? (
          <Box className={styles.editorBox}>
            <CommentEditor
              value={value}
              placeholder={props.placeholder}
              onChange={(value: string) => {
                setValue(value);
                props.onChange(value);
              }}
              ref={editorRef}
              extended={!props.simple}
              newFormats={props.newFormats}
            />
            {props.editorNotification && (
              <Typography className={styles.editorNotification}>
                {props.editorNotification}
              </Typography>
            )}
          </Box>
        ) : (
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={props.rows || 3}
            maxRows={props.rowsMax || 10}
            placeholder={props.placeholder}
            value={value}
            ref={editorRef}
            onChange={(evt: any) => {
              setValue(evt.target.value);
              props.onChange(evt.target.value);

            }}
          />
        )}
      </Grid>
      {hasPanel ? (
        <Grid item>
          <Box className={styles.hints}>
            {props.hint ? (
              <MUITooltip placement="top" title={props.hint} />
            ) : null}
            {props.attachAllowed ? (
              <>
                <Button
                  variant="contained"
                  className="MuiButton-iconAction"
                  onClick={onFileAdd}
                  classes={buttonClasses}
                >
                  <SvgIcon type="courses-attach" />
                </Button>
                {isFilestorageOpen ? (
                  <div style={{ display: "block" }}>
                    <EmbededFilestorage
                      data={{
                        key: "hw-filestorage",
                        isWidget: true,
                        module: "panel",
                        type: "all",
                        course_id: props.attachCourse,
                        tab: "all",
                        canDelete: false,
                        canDownload: false,
                        canEdit: false,
                        onAttach: (data: any) => {
                          onFileAddConfirm(data);
                        },
                        onCancel: () => {
                          setFilestorageOpen(false);
                        },
                      }}
                    />
                  </div>
                ) : null}
              </>
            ) : null}
            {props.editorAllowed ? (
              <Button
                variant="contained"
                color={editor ? "primary" : undefined}
                className="MuiButton-iconAction"
                classes={buttonClasses}
                onClick={() => {
                  handleEditorChange(!editor);
                }}
              >
                <SvgIcon type={`editor-format ${editor ? "white" : ""}`} />
              </Button>
            ) : null}
            {props.onPreview ? (
              <Button
                variant="contained"
                className="MuiButton-iconAction"
                onClick={props.onPreview}
                classes={buttonClasses}
              >
                <SvgIcon type="courses-preview" />
              </Button>
            ) : null}
          </Box>
        </Grid>
      ) : null}
    </Grid>
  );
};